import { useEffect, useState } from 'react';

import { isUndefined } from 'lodash';
import { useMediaQuery } from 'react-responsive';
import { useAccountSelector } from 'src/hooks';
import { MFormSection, MTypography } from 'src/lib';
import { Color, ScreenBreakpoint, Spacing } from 'src/styles';

import { JointAccountInterestForm } from './JointAccountInterestForm';
import { JointAccountInterestView } from './JointAccountInterestView';

export const JointAccountInterestSection = () => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();
  const isMobile = useMediaQuery({ query: `(max-width: ${ScreenBreakpoint.mobile.max})` });

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  const isPercentInterestAlreadySaved = () =>
    !isUndefined(account?.primaryAccountHolder?.jointTenantsInCommonInterestPercent) &&
    !isUndefined(account?.secondaryAccountHolder?.jointTenantsInCommonInterestPercent);

  useEffect(() => {
    if (isPercentInterestAlreadySaved() && !Boolean(account?.accountId)) {
      setIsEditable(true);
    }
  }, [account]);

  if (!account?.type.isJoint || !account?.jointAccountType?.isTenantsInCommon) {
    return null;
  }

  return (
    <>
      {isMobile && account?.type.isJoint && account.jointAccountType?.isTenantsInCommon && (
        <MTypography variant='h4' weight='normal' color={Color.Brand6} className={Spacing.my32}>
          Tenants in Common
        </MTypography>
      )}
      <MFormSection
        title='Tenants in Common Interest Percent'
        onEdit={onEdit}
        disabled={Boolean(account?.lastFailedLinkAttemptError)}
        isEditable={isEditable}
        isEditMode={isEditMode}
        tooltip={{
          type: 'modal',
          icon: 'info',
          title: 'Tenants in Common Interest Percent',
          label: 'Please specify each account holder’s share of interest. Total must equal 100%.',
          content: (
            <MTypography variant='body1'>
              Please specify each account holder’s share of interest. Total must equal 100%.
            </MTypography>
          ),
        }}
        testId={'tenants-in-common'}>
        {isPercentInterestAlreadySaved() && !isEditMode ? (
          <JointAccountInterestView account={account} />
        ) : (
          <JointAccountInterestForm account={account} onCancel={onCancel} />
        )}
      </MFormSection>
    </>
  );
};
